import React, { Component } from 'react';
import * as getTotalItems from '../../services/dashboardService'
import Card from './Card'
import Loader from "react-loader-spinner";
class Cards extends Component {
    state = { 
        Cards:[
            {
                id:1,
                title:'Total Files',
                SVG:<svg className="w-6 h-6 p-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round"
                strokeLinejoin="round"  strokeWidth="2"
                 d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"></path>
                 </svg>,
                cardBackgroundColor:"#0086FF"
            },
            {
                id:2,
                title:'Total Users',
                SVG:<svg className="w-6 h-6 p-1" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                 d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>,
                 cardBackgroundColor:"#2DCD3D"
            },
            {
                id:3,
                title:'Departments',
                SVG:<svg className="w-6 h-6 p-1" fill="none" stroke="currentColor"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                 d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z" /></svg>,
                 cardBackgroundColor:"#8574EE"
            },
            {
                id:4,
                title:'Collections',
                SVG:<svg className="w-6 h-6 p-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" 
                 strokeLinejoin="round" strokeWidth={2} 
                 d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" /></svg>,
                 cardBackgroundColor:"#FF005C"
            },
        ],
        totalUsers:"",
        totalFiles:"",
        totalCollections:"",
        totalDepartments:"",
        isLoading:true
     }
     componentDidMount = async() => {
        let Users = await getTotalItems.getTotalNumberOfUsers()
        let Departments = await getTotalItems.getTotalNumberOfDepartments()
        let Files = await getTotalItems.getTotalNumberOfFiles()
        let Collections = await getTotalItems.getTotalNumberOfCollections()
        let totalFiles = await Files.data.total
        let totalCollections = await Collections.data.total
        let totalDepartments = await Departments.data.total
        let totalUsers = await Users.data.total
        this.setState({totalUsers})
        this.setState({totalDepartments})
        this.setState({totalFiles})
        this.setState({totalCollections})
        this.setState({isLoading:false})
     };
     
     
    render() { 
        let { Cards,totalCollections,totalDepartments ,totalFiles,totalUsers,isLoading  } = this.state;
        let { user } = this.props
         //Check Auth User Role And Render Different Cards
        return ( 
            
            <div className="grid lg:grid-cols-4 gap-8">            
              {user.is_admin ? 
                Cards.map(card=> <div className="col-span-1">
                <Card 
                key={card.id}
                totalDepartments = {totalDepartments}
                totalCollections = {totalCollections}
                totalFiles = {totalFiles}
                totalUsers = {totalUsers}
                title={card.title}
                SVG={card.SVG}
                cardBackgroundColor={card.cardBackgroundColor}
                isLoading = {isLoading}
                />
              </div>): 
                     <React.Fragment>
                    <div>

                    </div>
                      <div className="bg-white  px-6 py-8 rounded-lg">
                        <div className="flex">
                            <div className="badge rounded" style={{ backgroundColor:'#0086FF' }}>
                            <div className="text-white">
                            <svg className="w-6 h-6 p-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round"
                        strokeLinejoin="round"  strokeWidth="2"
                        d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"></path>
                        </svg>
                            </div>
                            </div>
                            <span className="font-semibold  ml-2">Files</span>
                        </div>
                        <div className="mt-4">
                           {
                               !isLoading &&
                              <span className="font-extrabold text-4xl">
                               {totalFiles}
                           </span>
                           }
                           {
                               isLoading && 
                               <Loader
                                    type="Puff"
                                    color="#F35D2D"
                                    height={40}
                                    className="ml-4"
                                    width={40} />
                           }
                        </div>
                  </div>
                        <div className="bg-white  px-6 py-8 rounded-lg">
                                <div className="flex">
                                    <div className="badge rounded" style={{ backgroundColor :"#FF005C" }}>
                                     <div className="text-white">
                                     <svg className="w-6 h-6 p-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" 
                                strokeLinejoin="round" strokeWidth={2} 
                                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" /></svg>
                                     </div>
                                    </div>
                                    <span className="font-semibold  ml-2">Collections</span>
                                </div>
                    <div className="mt-4">
                    {
                               !isLoading &&
                              <span className="font-extrabold text-4xl">
                               {totalCollections}
                           </span>
                           }
                           {
                               isLoading && 
                               <Loader
                                    type="Puff"
                                    color="#F35D2D"
                                    height={40}
                                    className="ml-4"
                                    width={40} />
                           }
                    </div>
                    </div>
                    </React.Fragment>
             
              }
            </div>
         );
    }
}
 
export default Cards;